import * as mobx from 'mobx';
import { IntlShape } from 'react-intl';
import { ConnectionVersion } from '../../../../../../../constants/common.constants';
import { hasPermission } from '../../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../../api/roles.dao';

class UploadMeetingsFormDataVM {
    @mobx.observable
    public separatorToken: string;
    @mobx.observable
    public groupingStrategy: string;
    @mobx.observable
    public duration: string;
    @mobx.observable
    public selectedTimeZone: string;
    @mobx.observable
    public meetingsField: File;
    @mobx.observable
    public dateFormatType: string;
    @mobx.observable
    public date: number;
    @mobx.observable
    public connectionVersion: ConnectionVersion;
    @mobx.observable
    private isFormChecked: boolean;

    private intl: IntlShape;

    constructor(intl: IntlShape) {
        this.duration = '50';
        this.separatorToken = ',';
        this.selectedTimeZone = 'America/Lima';
        this.meetingsField = null;
        this.dateFormatType = null;
        this.connectionVersion = hasPermission(Permission.CREATE_MEETINGS_V2) ? ConnectionVersion.V2 : ConnectionVersion.V1;
        this.intl = intl;
    }

    public showValidationErrors() : boolean {
        return this.isFormChecked;
    }

    public getSeparatorTokenError(): string | null {
        if (this.separatorToken.trim().length === 0) {
            return this.intl.formatMessage({
                id: 'oe.error.required',
                defaultMessage: 'This field is required',
                description: 'Error message text'
            });
        }
        if (this.separatorToken.trim().length > 1) {
            return this.intl.formatMessage({
                id: 'oe.error.separatorTokenMustBeSingleCharacter',
                defaultMessage: 'Separator token must be single character',
                description: 'Error message text'
            });
        }

        return null;
    }

    public getDurationError(): string | null {
        return (this.duration.length && (/^[1-9]{1}[0-9]*$/.exec(this.duration)) !== null) ? null : this.intl.formatMessage({
            id: 'oe.error.invalidDuration',
            defaultMessage: 'Invalid duration',
            description: 'Error message text'
        });
    }

    public getMeetingFieldError(): string | null {
        return this.meetingsField !== null ? null : this.intl.formatMessage({
            id: 'oe.error.required',
            defaultMessage: 'This field is required',
            description: 'Error message text'
        });
    }

    public getDateFormatFieldError(): string | null {
        return this.dateFormatType !== null ? null : this.intl.formatMessage({
            id: 'oe.error.required',
            defaultMessage: 'This field is required',
            description: 'Error message text'
        });
    }

    @mobx.action
    public isFormValid(): boolean {
        return !this.getDurationError()
            && !this.getMeetingFieldError()
            && !this.getDateFormatFieldError()
            && !this.getSeparatorTokenError();
    }

    @mobx.action
    public allowToShowValidationErrors() {
        this.isFormChecked = true;
    }

    @mobx.action
    public setDate(date: number) {
        this.date = date;
    }

    @mobx.action
    public setMeetingsField = (file: File) => {
        this.meetingsField = file;
    };

    @mobx.action
    public toggleConnectionVersion = (): void => {
        if (this.isV2ConnectionVersion()) {
            this.connectionVersion = ConnectionVersion.V1;
        } else {
            this.connectionVersion = ConnectionVersion.V2;
        }
    };

    public isV2ConnectionVersion(): boolean {
        return this.connectionVersion === ConnectionVersion.V2;
    }
}

export { UploadMeetingsFormDataVM };